var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kt_header",staticClass:"kt-header kt-grid__item",class:_vm.headerClasses,attrs:{"id":"kt_header"}},[_c('div'),_c('KTTopbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }